"use client"

import { Toaster } from "sonner"

import { AuthProvider } from "@/lib/auth/auth-context"
import { type AuthUser, type Company } from "@/lib/api/types"

interface ProvidersProps {
  children: React.ReactNode
  initialUser?: AuthUser | null
  initialHasCompany?: boolean
  initialCompanies?: Company[]
  initialCurrentCompanyId?: string | null
}

export function Providers({
  children,
  initialUser,
  initialHasCompany,
  initialCompanies,
  initialCurrentCompanyId,
}: ProvidersProps) {
  return (
    <AuthProvider
      initialUser={initialUser}
      initialHasCompany={initialHasCompany}
      initialCompanies={initialCompanies}
      initialCurrentCompanyId={initialCurrentCompanyId}
    >
      {children}
      <Toaster richColors position="top-right" closeButton />
    </AuthProvider>
  )
}
